import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { supabase } from "@/integrations/supabase/client";

const OnboardingIntro = () => {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) navigate("/auth", { replace: true });
    });
  }, [navigate]);

  return (
    <div
      className="relative min-h-screen overflow-hidden flex items-center justify-center px-6 py-16"
      style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background:
          "radial-gradient(ellipse at top, #2a0a4a 0%, #1a0533 35%, #0a0118 75%, #050010 100%)",
      }}
    >
      {/* Ambient purple glow */}
      <div
        className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(147,51,234,0.18) 0%, rgba(126,34,206,0.08) 40%, transparent 70%)",
          filter: "blur(60px)",
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 w-full max-w-[820px] text-center"
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="text-5xl sm:text-6xl md:text-7xl font-bold text-white leading-[1.05] tracking-tight mb-10"
        >
          Let's calibrate your engine.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="text-xl sm:text-2xl md:text-[28px] text-white max-w-[760px] mx-auto leading-relaxed mb-16 font-normal"
        >
          Give us 60 seconds to understand your vision. We'll combine your goals with
          our website scan to build a high-performance SEO strategy — completely on
          autopilot.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="relative inline-block"
        >
          <div className="absolute inset-0 bg-purple-500/50 blur-[36px] rounded-full pointer-events-none animate-[introGlowPulse_2.4s_ease-in-out_infinite]" />
          <button
            onClick={() => {
              sessionStorage.setItem("orbit_intro_seen", "1");
              navigate("/onboarding");
            }}
            className="relative inline-flex items-center justify-center gap-2 px-10 h-16 rounded-full text-lg font-semibold text-white bg-gradient-to-r from-purple-600 to-fuchsia-500 shadow-[0_0_50px_rgba(168,85,247,0.55)] hover:shadow-[0_0_80px_rgba(168,85,247,0.85)] hover:scale-[1.04] active:scale-[1.0] transition-all duration-300"
          >
            Let's do it
            <span className="text-xl">→</span>
          </button>
        </motion.div>
      </motion.div>

      <style>{`
        @keyframes introGlowPulse {
          0%, 100% { opacity: 0.55; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.08); }
        }
      `}</style>
    </div>
  );
};

export default OnboardingIntro;
